import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';

@Component({
  standalone: false,
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionHeaderComponent {
  @Input() title: string;
  @Output() click = new EventEmitter<Popover>();
  @Input() optionHeader: Popover;
  @Input() permission: any = null;

  ellipsisClick(event: MouseEvent) {
    toggleEllipsisPopover(event, this.optionHeader);
  }
}
